export const CommonAccTypePolicy = ({
    ITEM_RATE: "RATE",
    ITEM_QTY: "QTY"
})